import { useState, useEffect } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'
import { useOrgContext } from '~/common/context/organization/org-context'

export const useSeasonList = ({ farmId }) => {
  const [seasons, setSeasons] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { seasonListRefreshKey } = useOrgContext()

  useEffect(() => {
    async function fetchSeasons() {
      if (!farmId) {
        setSeasons([])
        setLoading(false)
        setError(null)
        return
      }

      setLoading(true)
      setError(null)
      try {
        const { data, error: err } = await supabaseGetter.seasons.getByFarm(farmId)
        if (err) throw err
        setSeasons(data || [])
      } catch (err) {
        console.error('[useSeasonList] Error:', err)
        setError(err.message)
        setSeasons([])
      } finally {
        setLoading(false)
      }
    }

    fetchSeasons()
  }, [farmId, seasonListRefreshKey])

  return { seasons, loading, error, invalidate: supabaseGetter.seasons.invalidate }
}
